import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AlertDetailItemStyles";
import { alertsActions } from "../_actions";
import moment from "moment";

export default class AlertDetailItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.viewings.length !== 0 && props.assessments.length < 1
    };
  }

  toggleExpanded(id) {
    //const unix = Math.round(+new Date()/1000);
    //if (!this.state.expanded) this.props.dispatch(alertsActions.setViewing(id, unix))
    this.setState({ expanded: !this.state.expanded });
  }

  setCorrect(user, correct, id) {
    const unix = Math.round(+new Date() / 1000);
    this.props.dispatch(alertsActions.setCorrect(user, correct, id, unix));
  }

  render() {
    const {
      user,
      id,
      timestamp,
      assessments,
      level,
      name,
      text,
      icon
    } = this.props;

    return (
      <div id={`alert${id}`} className={css(styles.itemWrapper)}>
        <div
          className={css(
            styles.alert,
            this.state.expanded && styles.alertClosed
          )}
        >
          <div
            onClick={() => this.toggleExpanded(id)}
            className={css(
              styles.header,
              level === "Warning" && styles.warning,
              level === "Urgent" && styles.emergency,
              this.state.expanded && styles.headerClosed
            )}
          >
            <span className={css(styles.headerTitle)}>
              {level === "Warning"
                ? "Investigate"
                : level === "Urgent"
                ? "Urgent"
                : "Message"}
            </span>
            <span className={css(styles.headerTime)}>
              {moment.unix(timestamp).format("h:mma")}
            </span>
            <span
              className={css(
                this.state.expanded
                  ? styles.headerToggleShow
                  : styles.headerToggleHide
              )}
            >
              {this.state.expanded ? "Show" : "Hide"}
            </span>
          </div>
          {!this.state.expanded && (
            <Fragment>
              <div className={css(styles.body)}>
                <span className={css(styles.bodyTitle)}>
                  <img className={css(styles.icon)} src={icon} alt="" />
                  {name}
                </span>
                <span className={css(styles.bodyText)}>{text}</span>
              </div>
            </Fragment>
          )}
          {!this.state.expanded && !assessments.length && (
            <Fragment>
              <div className={css(styles.buttonContainer)}>
                <a
                  onClick={() => this.setCorrect(user, false, id)}
                  className={css(styles.incorrectButton)}
                >
                  Incorrect
                </a>
                <a
                  onClick={() => this.setCorrect(user, true, id)}
                  className={css(styles.correctButton)}
                >
                  Correct
                </a>
              </div>
            </Fragment>
          )}
          {!this.state.expanded && assessments.length ? (
            <Fragment>
              <div
                className={css(
                  assessments && assessments[0].correct
                    ? styles.correctContainer
                    : styles.incorrectContainer
                )}
              >
                {`Marked as ${
                  assessments && assessments[0].correct
                    ? "correct"
                    : "incorrect"
                }`}
              </div>
              <div className={css(styles.paddedContainer)}>
                <a
                  href={`/parents-home/alert-feedback/${id}`}
                  className={css(styles.buttonGreen)}
                >
                  Send Feedback
                </a>
              </div>
            </Fragment>
          ) : null}
        </div>
      </div>
    );
  }
}
